import { render, staticRenderFns } from "./ageEditor.vue?vue&type=template&id=5f415c14&"
import script from "./ageEditor.vue?vue&type=script&lang=js&"
export * from "./ageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports